/* eslint-disable import/no-named-as-default-member */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useEffect, useRef } from 'react';
import { DEFAULT_PAGINATE } from 'constants/defaultValues';
import { DEPARTURE_TYPE_OPTIONS } from 'constants/options';
import API from 'constants/api';
import SITELINKS from 'constants/sitelinks';
import { TableDateTimeFormat } from 'constants/dateFormats';
import store from 'redux/configureStore';
import PaqueryTable from '@paquery-team/lib-table';
import dayjs from 'dayjs';
import externalCodeColumn from 'components/tables/columns';
import { createUseStyles } from 'react-jss';
import {
  Button,
  Col,
  notification,
  Row,
  Select,
  Modal,
  Input,
  theme,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'redux/packageDeparture/slice';
import { actions as ppointDepartureActions } from 'redux/packagePaquerypointDeparture/slice';
import { selectGlobals } from 'redux/globals/selectors';
import { authPaquerypointSelector } from 'redux/auth/selectors';
import {
  paquerypointsItemsSelector,
  paquerypointsLoadedSelector,
} from 'redux/paquerypoint/selectors';
import { marketplacesItemsSelector } from 'redux/marketplaces/selectors';
import usePaquerypoints from 'redux/paquerypoint';
import useMarketplaces from 'redux/marketplaces';
import {
  DownCircleOutlined,
  ExclamationCircleOutlined,
  QrcodeOutlined,
} from '@ant-design/icons';
import { useDebounce } from 'util/Hooks';
import rest from 'util/Api';
import usePackageDeparture from 'redux/packageDeparture';
import usePackagePpointDeparture from 'redux/packagePaquerypointDeparture';
import {
  packageDepartureDestinySelector,
  packageDepartureTypeSelector,
} from 'redux/packageDeparture/selectors';
import {
  packagePaquerypointFilteredItemsSelector,
  packagePaquerypointDepartureItemsSelector,
  packagePaquerypointDepartureLoadedSelector,
} from 'redux/packagePaquerypointDeparture/selectors';
import PackageSelectModal from 'components/packageSelectModal';
import QRScanner from 'components/QRScanner';
import SizeIndicator from 'components/sizeIndicator';
import EditRecordButton from 'components/editRecordButton';
import DeleteRecordButton from 'components/deleteRecordButton';
import Card from 'components/card';

const { Search } = Input;

const WAIT_INPUT_EXTERNAL_CODE = 600;

const useStylesDeparturePacket = createUseStyles((_theme) => {
  return {
    pageTitle: {
      letterSpacing: '-0.03cm',
      alignSelf: 'flex-start',
      height: 80,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      fontSize: '2em',
      boxShadow: '0px 0px 2px #c3c3c3',
      margin: '15px 15px 0 15px',
    },
    headerButtonContainer: {
      textAlign: 'center',
      alignItems: 'flex-end',
    },
    registerPacketInput: {
      boxShadow: `0px 0px 3px ${_theme.colorPrimary}`,
      border: `1px solid ${_theme.colorPrimary}`,
      outline: '1px solid transparent',
      transition: '100ms all linear',
      '&:focus': {
        boxShadow: `0px 0px 3px ${_theme.colorPrimary}`,
        border: `1px solid ${_theme.colorPrimary}`,
        outline: `1px solid ${_theme.colorPrimary}`,
      },
    },
    inputContainer: {
      '@media (max-width: 768px)': {
        marginTop: '20px',
      },
    },
    destinyInput: {
      '@media (min-width: 769px)': {
        marginLeft: '30px',
      },
    },
    registerInput: {
      '@media (min-width: 1025px)': {
        marginRight: '30px',
      },
    },
  };
});

const { confirm } = Modal;

externalCodeColumn.width = 200;

const deliveryTermColumn = {
  title: 'Plazo',
  dataIndex: 'deliveryTerm',
  width: 130,
};

const packageTypeColumn = {
  title: 'Tipo',
  dataIndex: 'packageType',
};

const zoneColumn = {
  title: 'Zona',
  dataIndex: 'zone',
  align: 'center',
};

const scheduledDateColumn = {
  title: 'Fecha Programada',
  dataIndex: 'scheduledDate',
  align: 'center',
};

const bundlesColumn = {
  title: 'Bultos',
  dataIndex: 'numberPackages',
  align: 'center',
};

const arrivedAtPaqueryPointDateColumn = {
  title: 'Arribó a PaqueryPoint',
  dataIndex: 'arrivedAtPaqueryPointDate',
  align: 'center',
};

const deleteAction = (packetID, packetCode) => {
  confirm({
    title: `¿Estás seguro de que deseas eliminar el paquete con código externo: ${packetCode} ?`,
    icon: <ExclamationCircleOutlined />,
    content: 'Esta accion no se puede deshacer',
    onOk() {
      store.dispatch(actions.removePacket(packetID));
    },
  });
};

const marketplaceColumn = {
  title: 'Marketplace',
  dataIndex: 'marketplace',
};

const sizeColumn = {
  title: 'Tamaño',
  dataIndex: 'packageSize',
  align: 'center',
  render: (text) => <SizeIndicator text={text[0]} />,
  sorter: true,
  sortDirections: ['descend'],
};

const editColumn = {
  align: 'center',
  render: (_, record) => (
    <EditRecordButton record={record} link={`${SITELINKS.packages.list}/id`} />
  ),
};

const removePackageColumn = {
  align: 'center',
  render: (_, record) => (
    <DeleteRecordButton
      onClick={() => deleteAction(record.id, record.externalCode)}
    />
  ),
};

const dataColumns = [
  externalCodeColumn,
  deliveryTermColumn,
  scheduledDateColumn,
  zoneColumn,
  packageTypeColumn,
  marketplaceColumn,
  bundlesColumn,
  sizeColumn,
];

const columnsLargeDevice = [...dataColumns, editColumn, removePackageColumn];

const columnsSmallDevice = [
  externalCodeColumn,
  editColumn,
  removePackageColumn,
];

const columnsMediumDevice = [
  externalCodeColumn,
  scheduledDateColumn,
  arrivedAtPaqueryPointDateColumn,
  zoneColumn,
  marketplaceColumn,
  editColumn,
  removePackageColumn,
];

const DeparturePaqueryPointPacket = () => {
  usePackageDeparture();
  usePackagePpointDeparture();
  usePaquerypoints({ initialize: true });
  useMarketplaces({ initialize: true });
  const searcherInput = useRef(null);
  const externalCodeInput = useRef(null);
  const { token } = theme.useToken();
  const classes = useStylesDeparturePacket({ theme: token });
  const dispatch = useDispatch();
  const globals = useSelector(selectGlobals);
  const originPaquerypoint = useSelector(authPaquerypointSelector);
  const [destinyOptions, setDestinyOptions] = useState([]);
  const [packageModal, setPackageModal] = useState(false);
  const [packageSearch, setPackageSearch] = useState('');
  const [suggestedPackages, setSuggestedPackages] = useState([]);
  const [packageOptions, setPackageOptions] = useState([]);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const departureType = useSelector(packageDepartureTypeSelector);
  const destiny = useSelector(packageDepartureDestinySelector);
  const paquerypoints = useSelector(paquerypointsItemsSelector);
  const paquerypointsLoaded = useSelector(paquerypointsLoadedSelector);
  const marketplaces = useSelector(marketplacesItemsSelector);
  const totalPpointPackages = useSelector(
    packagePaquerypointDepartureItemsSelector,
  );
  const totalPackages = totalPpointPackages;
  const loaded = useSelector(packagePaquerypointDepartureLoadedSelector);
  const { items: ppointItems, pageable: ppointPageable } = useSelector(
    (state) => packagePaquerypointFilteredItemsSelector(state, destiny),
  );
  const debouncedPackageSearch = useDebounce(
    packageSearch,
    WAIT_INPUT_EXTERNAL_CODE,
  );
  const [loading, setLoading] = useState(false);
  const [showScanner, setShowScanner] = useState(false);

  const getCurrentDepartureTypeOptions = () => {
    let destinationOptions;
    switch (departureType) {
      case DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT:
        destinationOptions = paquerypoints.map((destination) => ({
          label: destination.name,
          value: destination.id,
        }));
        break;
      default:
        break;
    }
    setDestinyOptions(destinationOptions);
  };

  const getPackage = async (externalCode) => {
    try {
      if (externalCode === null || externalCode === '') {
        const error = new Error('El codigo externo no puede ir vacío.');
        return error;
      }
      const searchParams = new URLSearchParams({
        page: 0,
        take: 1000,
        size: 1000,
        externalCode,
      });
      const packet = await rest.get(
        `${API.packages.findByExternalCodeDispatch}?${searchParams.toString()}`,
      );
      if (packet.data.content.length === 0) {
        throw new Error('El paquete con el codigo externo indicado no existe');
      }
      return packet.data.content;
    } catch (error) {
      setSuggestionsLoading(false);
      return notification.error({
        message: 'Ha ocurrido un error al encontrar el paquete',
        description: `No se ha encontrado el paquete con el código ${externalCode}`,
      });
    }
  };

  const checkPackageAvaiability = (packet) => {
    const packetInListing = totalPackages.find((item) => item.id === packet.id);
    if (packetInListing) {
      throw new Error(
        `El paquete ${packetInListing.externalCode} se encuentra asignado a: ${packetInListing.destinyName}`,
      );
    }
  };

  const assignPacket = ({ id }) => {
    try {
      const selectedPacket = suggestedPackages.find(
        (packet) => packet.id === id,
      );
      if (selectedPacket) {
        checkPackageAvaiability(selectedPacket);
        let selectedDestinyName;
        const packetWithDestiny = {
          ...selectedPacket,
          destinyID: destiny,
        };
        switch (departureType) {
          case DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT:
            selectedDestinyName = paquerypoints.find(
              (ppoint) => ppoint.id === destiny,
            )?.name;
            packetWithDestiny.destinyName = selectedDestinyName;
            dispatch(ppointDepartureActions.addPackage(packetWithDestiny));
            break;
          default:
            break;
        }
        notification.success({
          message: 'Asignación de paquete correcta',
          description: `El paquete ${selectedPacket.externalCode} fue asignado correctamente a ${selectedDestinyName}`,
        });
        setPackageModal(false);
        setPackageOptions([]);
      }
    } catch (error) {
      notification.error({
        message: 'Ha ocurrido un problema al asignar el paquete',
        description: error.message || 'Ha ocurrido un error en el servidor.',
      });
    } finally {
      setSuggestionsLoading(false);
    }
  };
  const buildListingPackage = (packet) => {
    return {
      ...packet,
      key: packet.id,
      externalCode: packet.externalCode,
      scheduledDate: packet.shippingScheduleDestination.scheduledDate
        ? dayjs(packet.shippingScheduleDestination.scheduledDate)
            .tz()
            .format(TableDateTimeFormat)
        : null,
      zone: packet.shippingScheduleDestination.zone?.name ?? 'Sin Zona',
      deliveryTerm: globals.deliveryTerm.find(
        (term) => term.value === packet.deliveryTerm,
      ).description,
      marketplace: marketplaces.find(
        (marketplace) => marketplace.id === packet.ownerID,
      )?.name,
      packageSize: globals.packages.size.find(
        (packSize) => packSize.value === packet.packageSize,
      ).name,
      packageType: globals.packages.type.find(
        (packType) => packType.value === packet.packageType,
      ).name,
    };
  };
  const getFilteredPackages = () => {
    let filteredPackages;
    if (ppointItems) {
      switch (departureType) {
        case DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT:
          filteredPackages = ppointItems.map((packet) =>
            buildListingPackage(packet),
          );
          break;
        default:
          filteredPackages = [];
          break;
      }
    }
    return filteredPackages;
  };
  const filteredPackages = getFilteredPackages();

  useEffect(() => {
    dispatch(ppointDepartureActions.initial());
    dispatch(actions.updateDepartureType(DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT));
  }, [dispatch]);

  useEffect(() => {
    getCurrentDepartureTypeOptions();
    dispatch(actions.resetFilters());
    dispatch(ppointDepartureActions.resetFilters());
    if (searcherInput.current) {
      searcherInput.current.state.value = '';
    }
  }, [departureType, dispatch, paquerypointsLoaded]);

  useEffect(() => {
    const getPackageSuggestions = async (externalCode) => {
      let receivedExternalCode = externalCode;
      // Check if the typed extCode is a scanned QR
      try {
        const qrCode = JSON.parse(externalCode);
        if (qrCode.id) {
          receivedExternalCode = qrCode.id;
        }
      } catch (e) {
        // not QR and it's okay
      }
      const fetchedPackets = await getPackage(receivedExternalCode);
      if (!fetchedPackets) {
        return;
      }
      let suggestedPackageOptions = fetchedPackets;
      if (suggestedPackageOptions.length === 0) {
        notification.info({
          title: 'Información',
          message: `No se ha encontrado el paquete con código externo: ${externalCode}`,
        });
        setSuggestionsLoading(false);
        setPackageOptions([]);
        return;
      }
      setSuggestedPackages(suggestedPackageOptions);
      if (suggestedPackageOptions.length > 1) {
        // If results are more than 1 packet, show modal and filter results by packages status allowed by ppoint.
        let filteredPackets = suggestedPackageOptions;
        if (departureType === DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT) {
          filteredPackets = filteredPackets.filter(
            (packet) =>
              !totalPpointPackages.some((item) => item.id === packet.id),
          );
        }
        if (!filteredPackets.length) {
          notification.info({
            message: 'No se ha podido registrar el paquete',
            description:
              'Asegurese de que el paquete se encuentra en un estado permitido para despachar',
          });
          return;
        }
        suggestedPackageOptions = filteredPackets.map((packet) => {
          return {
            ...packet,
            marketplace: marketplaces.find((mkp) => mkp.id === packet.ownerID)
              ?.name,
            destinationAddress:
              packet.shippingScheduleDestination.shippingAddress.addressDetail,
            statusDescription: globals.packages.status.find(
              (state) => state.value === packet.status,
            ).name,
          };
        });
        if (suggestedPackageOptions.length > 1) {
          setPackageModal(true);
          setSuggestionsLoading(false);
          setPackageOptions(suggestedPackageOptions);
        } else {
          setSuggestedPackages(suggestedPackageOptions);
        }
      }
    };
    if (debouncedPackageSearch) {
      setPackageSearch('');
      setPackageOptions([]);
      setSuggestedPackages([]);
      setSuggestionsLoading(true);
      getPackageSuggestions(debouncedPackageSearch);
    }
    return undefined;
  }, [debouncedPackageSearch]);

  useEffect(() => {
    if (suggestedPackages.length === 1) {
      assignPacket(...suggestedPackages);
    }
  }, [suggestedPackages]);

  const handleCloseModal = () => {
    setPackageModal(false);
    setPackageOptions([]);
  };

  const departurePackages = () => {
    const departurePackagesAction = async (currentRedux, payload) => {
      setLoading(true);
      try {
        const packageIds = payload.dispatchDetails.map(
          (items) => items.packageId,
        );
        const result = await rest.post(API.departures.create, payload);
        if (rest.isSuccessResponse(result)) {
          notification.success({
            message: 'Paquetes despachados correctamente',
            description: `Los paquetes han sido despachados correctamente.`,
          });
          dispatch(currentRedux.dispatchPackagesSuccess(packageIds));
        }
      } catch (error) {
        notification.error({
          message: 'Error al despachar los paquetes',
          description:
            error.message || 'Ha ocurrido un error al generar el despacho.',
        });
        dispatch(currentRedux.failure());
      } finally {
        setLoading(false);
      }
    };
    let packages;
    let departureDestiny;
    let currentRedux;
    switch (departureType) {
      case DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT:
        packages = totalPpointPackages;
        departureDestiny = paquerypoints;
        currentRedux = ppointDepartureActions;
        break;
      default:
        break;
    }
    dispatch(currentRedux.dispatchPackages());
    const destination = departureDestiny.find((item) => item.id === destiny);
    const destinationPackages = packages.filter(
      (packet) => packet.destinyID === destiny,
    );
    const dispatchDetails = destinationPackages.map((packet) => {
      return {
        packageId: packet.id,
      };
    });
    const payload = {
      dispatchType: departureType,
      originDetail: originPaquerypoint.detail,
      originType: DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT,
      originId: originPaquerypoint.id,
      destinationType: departureType,
      destinationId: destination.id,
      destinationDetail: destination.detail,
      dispatchDetails,
    };
    departurePackagesAction(currentRedux, payload);
  };

  const handleDeparture = async () => {
    if (!destiny) {
      notification.info({
        message: 'No hay paquetes para generar despacho',
        description: `Asegúrese de asignar paquetes al destino antes de despachar`,
      });
      return;
    }
    switch (departureType) {
      case DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT:
        if (ppointItems.length < 1) {
          notification.info({
            message: 'No hay paquetes para generar despacho',
            description: `Asegúrese de asignar paquetes al destino antes de despachar`,
          });
          return;
        }
        break;
      default:
        break;
    }
    departurePackages();
  };

  // TODO: limpiar input y hacerle foco para que escaneen uno atrás del otro.

  const searchCallback = useCallback(
    (searchText) => {
      dispatch(actions.updateSearch(searchText));
      dispatch(ppointDepartureActions.updateSearch(searchText));
    },
    [dispatch, departureType],
    // TODO: quitar departuretype de acá porque actualiza search cuando cambio de departuretype
  );
  const searcher = {
    key: 'searchCodeOrDestinationName',
    onSearching: searchCallback,
    placeholder: 'Nombre',
    ref: searcherInput,
  };
  const updatePaginate = useCallback(
    (page) => {
      dispatch(actions.updatePageable(page));
      dispatch(ppointDepartureActions.updatePageable(page));
    },
    [dispatch],
  );

  const getPagination = () => {
    let pagination;
    switch (departureType) {
      case DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT:
        pagination = ppointPageable;
        break;
      default:
        break;
    }
    return pagination;
  };

  const currentPageable = getPagination();

  const handleScanQR = (data) => {
    if (data) {
      setPackageSearch(data);
      setShowScanner(false);
    }
  };

  return (
    <>
      <QRScanner
        onScan={handleScanQR}
        showCamera={showScanner}
        setShowCamera={setShowScanner}
      />
      <PackageSelectModal
        visible={packageModal}
        packages={packageOptions}
        handleCloseModal={handleCloseModal}
        handlePackageSelection={assignPacket}
      />
      <Card title="Transferir paquetes" style={{ marginBottom: '10px' }}>
        <Row
          align="middle"
          className={classes.headerButtonContainer}
          justify="end"
        >
          <Col xs={24} lg={15} xl={14}>
            <Row
              gutter={[16, 16]}
              align="bottom"
              justify="space-around"
              className={classes.inputContainer}
            >
              <Col xs={24} lg={9}>
                <span>Destino:</span>
                <Select
                  style={{ width: '100%' }}
                  showSearch
                  value={destiny}
                  placeholder="Seleccione un destino"
                  onChange={(newDestiny) => {
                    dispatch(actions.updateDestiny(newDestiny));
                    dispatch(ppointDepartureActions.resetFilters());
                  }}
                  filterOption={(input, option) =>
                    option.label.toUpperCase().includes(input.toUpperCase())
                  }
                  options={destinyOptions}
                />
              </Col>
              <Col xs={24} lg={9}>
                <div>
                  <DownCircleOutlined />
                  Registrar paquete:
                </div>
                <Search
                  ref={externalCodeInput}
                  value={packageSearch}
                  disabled={!destiny}
                  onChange={(e) => setPackageSearch(e.target.value.trim())}
                  loading={suggestionsLoading}
                />
              </Col>
              <Col xs={24} lg={5}>
                <Button
                  disabled={!destiny}
                  style={{ width: '100%' }}
                  icon={<QrcodeOutlined />}
                  type="primary"
                  onClick={() => setShowScanner(true)}
                  loading={suggestionsLoading}
                >
                  Scan QR
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
      <Row
        className={classes.pageContainer}
        align="stretch"
        style={{ marginTop: -15 }}
      >
        <Col
          xs={24}
          className={classes.tablePacketContainer}
          style={{ marginTop: 15 }}
        >
          <PaqueryTable
            loading={!loaded}
            header={{
              searcher,
            }}
            onChangePaginate={updatePaginate}
            dataSource={filteredPackages}
            paginate={currentPageable || DEFAULT_PAGINATE}
            dataColumns={dataColumns}
            colsForSmallDevice={columnsSmallDevice}
            colsForMediumDevice={columnsMediumDevice}
            colsForLargeDevice={columnsLargeDevice}
          />
        </Col>
      </Row>
      <Row align="middle" style={{ textAlign: 'center', margin: '10px 0px' }}>
        <Col xs={24}>
          <Button
            type="primary"
            size="large"
            onClick={handleDeparture}
            loading={loading}
          >
            Transferir
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default DeparturePaqueryPointPacket;
